import '@sitecore-jss/sitecore-jss-nextjs';
import { GetServerSideProps } from 'next';
import SitecorePage, { LayoutServiceDataWithRedirectUrl } from 'src/pages/[[...path]]';

import { getEnvVariables } from 'src/hooks/useEnvVariables';

import { isPhantomOfficePage } from 'src/utils/isPhantomOfficePage';

import { deleteNextjsCachedFiles } from 'lib/deleteNextjsCachedFiles';
import { sitecorePagePropsFactory } from 'lib/page-props-factory';

export const getServerSideProps: GetServerSideProps = async (context) => {
  const updatedContext: typeof context = {
    ...context,
    params: {
      ...context.params,
      path: [
        typeof context.params?.site === 'string' ? context.params.site : '_site_main',
        ...(Array.isArray(context.params?.path) ? context.params.path : []),
      ],
    },
  };

  const props = await sitecorePagePropsFactory.create(updatedContext);

  const customLayoutData = props.layoutData as LayoutServiceDataWithRedirectUrl;

  // Check if we have a redirect via the redirects module. Note: redirectUrl is not populated when FETCH_WITH=GraphQL
  if (customLayoutData?.sitecore?.context?.redirectUrl) {
    return {
      redirect: {
        destination: customLayoutData.sitecore.context.redirectUrl,
        permanent: true,
      },
    };
  }

  // Check if we have a redirect (e.g. custom error page)
  if (props?.redirect) {
    return {
      redirect: props.redirect,
    };
  }

  // Logic to handle phantom offices, which do not have detail pages.
  if (isPhantomOfficePage(customLayoutData)) {
    await deleteNextjsCachedFiles(context);
    return {
      revalidate: 1,
      notFound: true,
    };
  }

  // Check if we are rendering the Professional/People TC Detail PDF page
  // If so, fetch the full list of related publications, news, and events
  return {
    props: {
      ...props,
      env: getEnvVariables(),
    },
    notFound: props.notFound, // Returns custom 404 page with a status code of 404 when true
  };
};

export default SitecorePage;
